import React, { Component } from 'react';
import './index.css'
import BsyTurnPage from "../BsyTurnPage";
import BsyDialog from "../BsyDialog";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyAlert from "../BsyAlert";
import BsySLoading from "../BsySLoading";
import BsySlidePane from "../BsySlidePane";
import NameCorrespondenceSetting from "./NameCorrespondenceSetting";
import DocumentTitle from "react-document-title";
import { BsyUtils } from '../../utils/Utils';
import { setPageTitle } from '../../utils/setPageTitle';

class BsyVirtualAddressBook extends Component {
  constructor(props) {
    super(props);
    // let appName = "";
    // props.apps && props.apps.map(res => {
    //   res.apps.map(res1 => {
    //     if (res1._id === props.appid) {
    //       appName = React.language("virtual.address.book") + " - " + res1.appname;
    //     }
    //     return null;
    //   })
    //   return null;
    // })
    this.state = {
      selectType: '1',
      addName: React.language("department"),
      skip: 0,
      limit: BsyUtils.Store.get("virtualAddressBookLimit1") || 20,
      count: 0,
      data: [],
      isloading: false,
      appName: props.appName,
    }
  }

  leftMenuList = [
    {
      name: React.language("department"),
      icon: "icon-bsy-dept",
      type: "1"
    }, {
      name: React.language("member"),
      icon: "icon-member-normal",
      type: "2"
    }, {
      name: React.language("role"),
      icon: "icon-bsy-role",
      type: "3"
    }, {
      name: React.language("outsiderGroup"),
      icon: "icon-bsy-outsider-group",
      type: "4"
    }, {
      name: React.language("outsider.member"),
      icon: "icon-widget-usergroup",
      type: "5"
    }, {
      name: React.language("subform.data.load.tip21"),
      icon: "icon-bsy-post",
      type: "6"
    }, {
      name: React.language("user.relation"),
      icon: "icon-bsy-line-relation",
      type: "7"
    },
  ]

  componentDidMount() {
    this.loadListData();
  }

  switchType = (res) => {
    return () => {
      this.setState({
        selectType: res.type,
        limit: BsyUtils.Store.get("virtualAddressBookLimit" + res.type) || 20,
        skip: 0,
        addName: res.name
      }, () => {
        this.loadListData();
      })
    }
  }

  loadListData = () => {
    const { selectType, skip, limit } = this.state;
    this.setState({ isloading: true }, () => {
      React.axios("/data/virtually_contacts_list", {
        appId: this.props.appid,
        type: selectType,
        skip: skip * limit,
        limit
      }).then(res => {
        const { list, count } = res.data
        this.setState({ data: list, count, isloading: false })
      })
    })
  }

  skipChange = (e) => {
    this.setState({ skip: e === -1 ? 0 : e, }, () => {
      this.loadListData();
    })
  }

  listLimitChange = (e) => {
    BsyUtils.Store.set("virtualAddressBookLimit" + this.state.selectType, e);
    this.setState({ limit: e, skip: 0 }, () => {
      this.loadListData();
    })
  }

  validateString = (inputString) => {
    let regex = /^[\u4e00-\u9fa5\w\s]+$/;
    // \u4e00-\u9fa5 表示中文字符范围，\w 表示字母、数字、下划线，\s表示空格

    // 使用test()方法检查输入字符串是否符合正则表达式模式
    return regex.test(inputString);
  }

  addDataName = "";
  addDataDesc = "";

  addChangeDataName = (e) => {
    this.addDataName = e.target.value.replace(/\s+/g, ' ');
    e.target.value = this.addDataName;
  }

  addChangeDataDesc = (e) => {
    this.addDataDesc = e.target.value.replace(/[\r\n]/g, '');
    e.target.value = this.addDataDesc;
  }

  addData = () => {
    const { addName, selectType } = this.state;
    this.addDataName = "";
    this.addDataDesc = "";
    BsyDialog({
      title: React.language("virtual.add.title", { name: addName }),
      width: 460,
      height: 490,
      okText: React.language("save"),
      cancelText: React.language("cancel"),
      onOk: () => {
        if (this.addDataName === "" || this.addDataName === " ") {
          tipAlert({
            type: "warning",
            msg: React.language("error.3001")
          })
          return false
        }
        if (!this.validateString(this.addDataName)) {
          tipAlert({
            type: "warning",
            msg: React.language("virtual.add.name.tip")
          })
          return false
        }
        React.axios("/data/add_virtually_contacts", {
          appId: this.props.appid,
          type: selectType,
          name: this.addDataName,
          remark: this.addDataDesc
        }).then(res => {
          if (res.data.code === 200) {
            tipAlert({
              type: "success",
              msg: React.language("form.ext.add.success")
            })
            this.loadListData();
          }
        })
      },
      onContentCreate: () => {
        return <div className="virtualAddContent">
          <div className="addItem name">
            <div className="itemTitle">
              <b>*</b>
              {React.language("corp.dingtalk.Step4.name")}
            </div>
            <div className="itemValue">
              <input type="text" autoFocus={true} maxLength={128} onChange={this.addChangeDataName} placeholder={React.language("virtual.add.name.placeholder", { name: addName })} />
            </div>
          </div>
          <div className="addItem desc">
            <div className="itemTitle">
              {React.language("corp.dingtalk.Step4.desc")}
            </div>
            <div className="itemValue">
              <textarea maxLength={1024} onChange={this.addChangeDataDesc} placeholder={React.language("virtual.add.describe.placeholder")} />
            </div>
          </div>
        </div>
      }
    })
  }

  editDataName = "";
  editDataDesc = "";

  editData = (res) => {
    return () => {
      const { addName, selectType } = this.state;
      this.editDataName = res.name;
      this.editDataDesc = res.remark;
      BsyDialog({
        title: React.language("virtual.edit.title", { name: addName }),
        width: 460,
        height: 490,
        okText: React.language("save"),
        cancelText: React.language("cancel"),
        onOk: () => {
          if (this.editDataName === "" || this.editDataName === " ") {
            tipAlert({
              type: "warning",
              msg: React.language("error.3001")
            })
            return false
          }
          if (!this.validateString(this.editDataName)) {
            tipAlert({
              type: "warning",
              msg: React.language("virtual.add.name.tip")
            })
            return false
          }
          React.axios("/data/update_virtually_contacts", {
            appId: this.props.appid,
            type: selectType,
            _id: res._id,
            name: this.editDataName,
            remark: this.editDataDesc
          }).then(res => {
            if (res.data.code === 200) {
              tipAlert({
                type: "success",
                msg: React.language("saveInfo.success")
              })
              this.loadListData();
            }
          })
        },
        onContentCreate: () => {
          return <div className="virtualAddContent">
            <div className="addItem name">
              <div className="itemTitle">
                <b>*</b>
                {React.language("corp.dingtalk.Step4.name")}
              </div>
              <div className="itemValue">
                <input type="text" autoFocus={true} maxLength={128} defaultValue={this.editDataName} onChange={this.editChangeDataName} placeholder={React.language("virtual.add.name.placeholder", { name: addName })} />
              </div>
            </div>
            <div className="addItem desc">
              <div className="itemTitle">
                {React.language("corp.dingtalk.Step4.desc")}
              </div>
              <div className="itemValue">
                <textarea maxLength={1024} defaultValue={this.editDataDesc} onChange={this.editChangeDataDesc} placeholder={React.language("virtual.add.describe.placeholder")} />
              </div>
            </div>
          </div>
        }
      })
    }
  }

  editChangeDataName = (e) => {
    this.editDataName = e.target.value.replace(/\s+/g, ' ');
    e.target.value = this.editDataName;
  }

  editChangeDataDesc = (e) => {
    this.editDataDesc = e.target.value.replace(/[\r\n]/g, '');
    e.target.value = this.editDataDesc;
  }

  removeData = (res) => {
    return () => {
      const { addName } = this.state;
      BsyAlert({
        title: React.language("virtual.delete.title", { name: res.name, type: addName }),
        type: "query",
        text4Ok: React.language("delete"),
        OkType: "pureRed",
        iconColor: "var(--bsy-base-error-color)",
        text4Cancel: React.language("cancel"),
        ok: () => {
          React.axios("/data/del_virtually_contacts", {
            appId: this.props.appid,
            _id: res._id
          }).then(res => {
            tipAlert({
              type: "success",
              msg: React.language("delete.success")
            })
            this.loadListData();
          })
        }
      })
    }
  }

  openCorrespondenceSetting = () => {
    BsySlidePane({
      title: React.language("virtual.name.correspondence.settings"),
      hasHeader: true,
      onContentCreate: (ref) => {
        return <NameCorrespondenceSetting appId={this.props.appid} slideRef={ref} />
      },
    })
  }

  render() {
    const { selectType, data, limit, skip, count, addName, isloading, appName } = this.state;
    setPageTitle(appName)
    return <div className="BsyVirtualAddressBook">
      <div className="virtualAddressBookContent">
        <div className="virtualAddressBookHeader">
          <div className="headerLeft">
            <span className="headerTitle">{React.language("virtual.address.book")}</span>
            <span className="headerMsg">{React.language("virtual.address.book.msg")}</span>
          </div>
          <div className="headerRight">
            <div className="nameSettingBtn" onClick={this.openCorrespondenceSetting}>{React.language("name.correspondence.settings")}</div>
          </div>
        </div>
        <div className="virtualAddressBookBody">
          <div className="bodyLeft">
            <div className="leftMenu">
              {
                this.leftMenuList.map(res => {
                  return <div className={`menuItem ${selectType === res.type ? "select" : ""}`} title={res.name} onClick={this.switchType(res)}>
                    <i className={res.icon}></i>
                    <span>{res.name}</span>
                  </div>
                })
              }
            </div>
          </div>
          <div className="bodyRight">
            {isloading && <BsySLoading style={{ background: '#ffffff' }}></BsySLoading>}
            <div className="listTable">
              <div className="tableHeader">
                <div className="headerTr">
                  <div className="headerTd name">{React.language("corp.dingtalk.Step4.name")}</div>
                  <div className="headerTd explain">{React.language("corp.dingtalk.Step4.desc")}</div>
                  <div className="headerTd operation">{React.language("order.operation")}</div>
                </div>
              </div>
              <div className="tableBody">
                {
                  data.map((res, key) => {
                    return <div className={`bodyTr ${(key + 1) % 2 === 0 ? "even" : ""}`}>
                      <div className="bodyTd name" title={res.name}>{res.name}</div>
                      <div className="bodyTd explain" title={res.name}>{res.remark}</div>
                      <div className="bodyTd operation">
                        <span className="operationBtn edit" onClick={this.editData(res)}>{React.language("edit")}</span>
                        <span className="operationBtn delete" onClick={this.removeData(res)}>{React.language("delete")}</span>
                      </div>
                    </div>
                  })
                }
              </div>
              <div className="tableFooter">
                <div className="addDataBtn" onClick={this.addData}>
                  <i className="icon-bsy-add"></i>
                  <span>{React.language("virtual.add", { name: addName })}</span>
                </div>
              </div>
            </div>
            <BsyTurnPage
              skipChange={this.skipChange}
              listLimitChange={this.listLimitChange}
              limit={limit}
              skip={skip}
              count={count}
            />
          </div>
        </div>
      </div>
    </div>

  }
}

export default BsyVirtualAddressBook;